import { createElement } from 'react';

import { ChuyenHuong } from '../../lib/guard.js';
import type { KhaiBaoModule } from '../../lib/modules.js';
import { TrangKetNoiCongKhai } from './pages/TrangKetNoiCongKhai.js';

const sync: KhaiBaoModule = {
  id: 'sync',
  /*
   * **Không khai `nav`**: "Kết nối API" nay là **mục của trang Cài đặt**
   * (`/cai-dat?tab=ket-noi-api`) — module khai mục ở `caiDatTabs.tsx` của chính
   * nó. Đường dẫn cũ `/ket-noi-api` chuyển hướng sang đó.
   */
  routes: [
    {
      path: '/ket-noi-api',
      element: createElement(ChuyenHuong, { den: '/cai-dat?tab=ket-noi-api' }),
      permission: { module: 'sync', level: 'view' },
    },
    /*
     * Trang cho **chủ kênh ngoài công ty** tự cấp quyền: `congKhai` nên không
     * bọc `CanDangNhap`, không dựng khung app và không gọi `/core/me`.
     */
    {
      path: '/ket-noi/:token',
      element: createElement(TrangKetNoiCongKhai),
      congKhai: true,
    },
  ],
};

export default sync;
